import { motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { DIAL_DURATION_MS } from 'src/lib/constants.ts';
import { DIAL_TRANSITION } from 'src/lib/motion.ts';
import { ResultType } from 'src/types/types.ts';

import { Eyebrow } from './eyebrow.tsx';

export function ScoreDial({ value, tone }: { value: number; tone: ResultType['tone'] }) {
  const pct = Math.max(0, Math.min(1, value / 5));
  const radius = 84;
  const circ = 2 * Math.PI * radius;
  const dash = circ * pct;
  const color = `var(--zeb-tone-${tone})`;

  const [shown, setShown] = useState(0);
  useEffect(() => {
    const start = performance.now();
    const dur = DIAL_DURATION_MS;
    let raf = 0;
    const tick = (t: number) => {
      const p = Math.min(1, (t - start) / dur);
      setShown(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);

  return (
    <div className="flex items-center justify-center">
      <div className="relative">
        <svg width={220} height={220} viewBox="0 0 220 220">
          <circle
            cx={110}
            cy={110}
            r={radius}
            fill="none"
            stroke="var(--zeb-muted)"
            strokeWidth={10}
          />
          <motion.circle
            cx={110}
            cy={110}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={10}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${circ}`}
            transform="rotate(-90 110 110)"
            initial={{ strokeDasharray: `0 ${circ}` }}
            animate={{ strokeDasharray: `${dash} ${circ}` }}
            transition={DIAL_TRANSITION}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <Eyebrow>Gesamtscore</Eyebrow>
          <div
            className="mt-1 text-display-lg leading-none tabular-nums text-zeb-tertiary"
            style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 700,
              letterSpacing: '-0.02em'
            }}>
            {shown.toFixed(1)}
          </div>
          <div className="mt-1 text-xs text-zeb-gray-500">von 5,0</div>
        </div>
      </div>
    </div>
  );
}
